export default __webpack_public_path__ + "static/media/slide15.a20485f6.jpg";